import React, { Component, Fragment } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Helmet from 'react-helmet'
import { translate } from 'react-i18next'
import {ThemeProvider} from 'styled-components'
import theme from './style/theme'

import Header from './layout/Header'
import Welcome from './pages/Welcome'
import Preview from './pages/Preview'

class App extends Component {
  constructor() {
    super()
    let mode = 'tv'
    if (window.matchMedia('(max-width: 1366px)').matches) mode = 'desktop'
    if (window.matchMedia('(max-width: 1024px)').matches) mode = 'laptop'
    if (window.matchMedia('(max-width: 640px)').matches) mode = 'tablet'
    if (window.matchMedia('(max-width: 360px)').matches) mode = 'mobile'

    this.state = {
      previewMode: mode,
      error: null,
      isLoaded: false,
      items: [],
    }
  }

  componentDidCatch(error, info) { // eslint-disable-line
    // console.log(error, info)
  }

  componentDidMount() {
    fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_TEMPLATES_ENDPOINT}`)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
          })
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          })
        }
      )
  }

  setPreviewMode (mode) {
    this.setState({
      previewMode: mode,
    })
  }

  render() {
    const { previewMode, isLoaded, error, items } = this.state
    const { t } = this.props

    return (
      <ThemeProvider theme={theme}>
        <Router>
          <Fragment>
            <Helmet titleTemplate={`JAM.ron - %s`}>
              <meta name="description" content={t('metaDescription')} />
            </Helmet>
            <Header items={items} previewMode={previewMode} setPreviewMode={this.setPreviewMode.bind(this)} />
            <main>
              {error && <div className="ajax-error">Error!</div>}
              {!isLoaded && <div className="ajax-spinner">Loading...</div>}
              <Switch>
                <Route exact path="/" render={props => <Welcome items={items} />} />
                <Route path="/preview/:id" render={props =>
                  <Preview mode={previewMode} {...props} />
                } />
                <Route component={NotFound} />
              </Switch>
            </main>
          </Fragment>
        </Router>
      </ThemeProvider>
    )
  }
}

const NotFound = () => (
  <Fragment>
    <Helmet title='Not Found' /><br/>
    <h2 style={{textAlign: 'center'}}>404</h2>
  </Fragment>
)

export default translate('app')(App)



// WEBPACK FOOTER //
// ./src/App.jsx